import { HistoricRow } from 'components/molecules/Historic/HistoricRow';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useHistoric } from 'hooks/useHistoric';

import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: 500,
  fontSize: 14,
}));

export const HistoricList: React.FC = () => {
  const { docs, loading } = useHistoric();

  return (
    <PaperCardTemplate loading={loading}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Data do Atendimento</StyledTableCell>

            <StyledTableCell>Nome do Tutor</StyledTableCell>

            <StyledTableCell>Nome do Pet</StyledTableCell>

            <StyledTableCell>Tipo de Consulta</StyledTableCell>

            <StyledTableCell align="center">
              <span style={{ paddingLeft: 40 }}>Ação</span>
            </StyledTableCell>
          </TableRow>
        </TableHead>

        {docs?.length < 1 && (
          <Typography component="caption">
            <Box textAlign="center">
              Não possui nenhum atendimento nesse período.
            </Box>
          </Typography>
        )}

        <TableBody>
          {docs?.map((item, index) => (
            <HistoricRow key={index} historic={item} />
          ))}
        </TableBody>
      </Table>
      {/* <TablePagination
        currentPage={page}
        maxPage={totalPages}
        onPreviousClick={handlePreviousPage}
        onNextClick={handleNextPage}
      /> */}
    </PaperCardTemplate>
  );
};

